import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import CITYIMAGE from "../assets/City.png";

const AllCategoriesTiles = ({ categories, t }) => {
    AllCategoriesTiles.propTypes = {
        categories: PropTypes.array.isRequired,
        t: PropTypes.func.isRequired,
    };

    const navigateTo = useNavigate();
    const scrollContainer = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const updateScrollability = () => {
            const width = window.innerWidth;
            let threshold = 4;

            if (width < 768) {
                threshold = 2; // small
            } else if (width >= 768 && width < 1024) {
                threshold = 3; // medium
            }

            setIsScrollable(categories.length >= threshold);
        };

        updateScrollability();  

        window.addEventListener("resize", updateScrollability);
        return () => window.removeEventListener("resize", updateScrollability);
    }, [categories]);

    const scrollLeft = () => {
        if (scrollContainer.current) {
            scrollContainer.current.scrollBy({ left: -300, behavior: "smooth" });
        }
    };

    const scrollRight = () => {
        if (scrollContainer.current) {
            scrollContainer.current.scrollBy({ left: 300, behavior: "smooth" });
        }
    };

    const getCategoryImage = (category) => {
        return category?.metadata?.logo || CITYIMAGE;
    };

    return (
        <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-10 space-y-10 flex flex-col items-center">
            <div className="flex items-center w-full relative">
                {isScrollable && (
                    <button
                        onClick={scrollLeft}
                        className="absolute hidden md:flex left-0 z-10 p-2 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg bg-gray-900 border-4 border-white"
                    >
                        ❮
                    </button>
                )}

                <div
                    ref={scrollContainer}
                    className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth w-full"
                    style={{ scrollSnapType: "x mandatory", whiteSpace: "nowrap" }}
                >
                    {Array.isArray(categories) &&
                        categories.map((category) => {
                            const categoryId = category.id;
                            const categoryName = category.name;

                            return (
                                <div
                                    key={categoryId}
                                    className="h-80 w-80 rounded-2xl cursor-pointer transition-transform duration-500 shadow-[0_3px_10px_rgb(0,0,0,0.2)] hover:scale-90 flex-shrink-0"
                                    style={{ scrollSnapAlign: "start" }}
                                    onClick={() => {
                                        const scrollPosition = window.scrollY;
                                        navigateTo(`/AllListings?categoryId=${categoryId}`);
                                        window.addEventListener("popstate", function () {
                                            window.scrollTo(0, scrollPosition);
                                        });
                                    }}
                                >
                                    <div className="relative h-80 rounded-2xl overflow-hidden">
                                        <img
                                            alt={categoryName}
                                            className="object-cover object-center rounded-lg h-full w-full"
                                            src={getCategoryImage(category)}
                                            loading="lazy"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = CITYIMAGE;
                                            }}
                                        />
                                        <div
                                            className="absolute inset-0 flex flex-col justify-end text-white"
                                            style={{
                                                background:
                                                    "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
                                            }}
                                        >
                                            <h1
                                                className="text-xl pb-5 md:text-3xl font-sans font-bold mb-0 ml-4"
                                                style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                                            >
                                                {categoryName}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>

                {isScrollable && (
                    <button
                        onClick={scrollRight}
                        className="absolute hidden md:flex right-0 z-10 p-2 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg bg-gray-900 border-4 border-white"
                    >
                        ❯
                    </button>
                )}
            </div>
        </div>
    );
};

export default AllCategoriesTiles;